export default "__VITE_ASSET__3ba1130a__"